/** 开发环境经 /app 代理到业务网关；生产留空则走根路径 */
const BACKEND_PREFIX = String(process.env.VUE_APP_BACKEND_PREFIX ?? '')
  .trim()
  .replace(/\/$/, '');

const LIYUAN_PATH_RE = /^\/liyuan-[a-z0-9-]+/i;
const API_GATEWAY_PATH_RE = /^\/api(?:\/|$)/i;
const LEAGUES_GATEWAY_PATH_RE = /^\/(leagues|auth)(?:\/|$)/i;
/** 用户服务在网关注册为 user（OpenAPI basePath 为 /liyuan-user） */
// const USER_GATEWAY_PATH_RE = /^\/user(?:\/|$)/i;
const LEAGUES_APP_PREFIX = '/app';

const SCOPE_RULES = {
  liyuan: LIYUAN_PATH_RE,
  api: API_GATEWAY_PATH_RE,
  leagues: LEAGUES_GATEWAY_PATH_RE,
  // user: USER_GATEWAY_PATH_RE,
};

/**
 * 为需走业务网关的路径加前缀（默认仅 /liyuan-*，不误伤 /sport、/mqtt 等）
 * - /api/leagues、/api/auth：不加 /app（生产 /api/...）
 * - 所有 /liyuan-*（含 liyuan-social）：走 VUE_APP_BACKEND_PREFIX（生产 /app → /app/liyuan-*）
 * @param {string} url
 * @param {{ scopes?: Array<'liyuan'|'api'|'leagues'> }} [options]
 */
export function withBackendPrefix(url, { scopes = ['liyuan', 'user'] } = {}) {
  const path = String(url ?? '').trim();
  if (!path) return path;
  if (/^https?:\/\//i.test(path)) return path;
  if (path === BACKEND_PREFIX || path.startsWith(`${BACKEND_PREFIX}/`)) return path;
  if (path === LEAGUES_APP_PREFIX || path.startsWith(`${LEAGUES_APP_PREFIX}/`)) return path;

  const shouldPrefix = scopes.some((scope) => SCOPE_RULES[scope]?.test(path));
  if (!shouldPrefix) return path;

  if (scopes.includes('leagues')) {
    return `${LEAGUES_APP_PREFIX}${path}`;
  }

  if (!BACKEND_PREFIX) return path;

  return `${BACKEND_PREFIX}${path}`;
}

/** baseURL（域名）+ 网关前缀 + 路径，供裸 axios 调用（如 token refresh） */
export function resolveApiUrl(path, options) {
  const base = String(process.env.VUE_APP_BASE_API ?? '')
    .trim()
    .replace(/\/$/, '');
  const url = withBackendPrefix(path, options);
  if (!base) return url;
  if (/^https?:\/\//i.test(url)) return url;
  return `${base}${url}`;
}
